// extracted by mini-css-extract-plugin
module.exports = {"root":"buI4_h","supContainer":"ETmrsv"};